import { FOfferType } from '../../../utils/category';

export const OfferTypeLabel: { [key: number]: string } = {
  [FOfferType.Bed]: 'bed',
  [FOfferType.Building]: 'building',
  [FOfferType.Land]: 'land',
  [FOfferType.CommercialLand]: 'commercialLand',
  [FOfferType.Flat]: 'flat',
  [FOfferType.FlatNew]: 'flat',
  [FOfferType.FlatOld]: 'flat',
  [FOfferType.FreeAppointmentObject]: 'freeAppointmentObject',
  [FOfferType.Garage]: 'garage',
  [FOfferType.House]: 'house',
  [FOfferType.HousePart]: 'houseShare',
  [FOfferType.Manufacture]: 'industry',
  [FOfferType.Office]: 'office',
  [FOfferType.Business]: 'business',
  [FOfferType.Room]: 'room',
  [FOfferType.Warehouse]: 'warehouse',
  [FOfferType.Townhouse]: 'townhouse',
  [FOfferType.TradeArea]: 'shoppingArea',
};

export const RoomsLabel: { [key: number]: string } = {
  1: 'oneRoom', // 'Однокомнатная квартира'
  2: 'twoRoom', // 'Двухкомнатная квартира'
  3: 'threeRoom', // 'Трехкомнатная квартира'
  4: 'fourRoom', // 'Четырехкомнатная квартира'
  5: 'fiveRoom', // 'Пятикомнатная квартира'
  6: 'large', // 'Многокомнатная квартира (6 и более комнат)'
  7: 'openPlan', // 'Квартира со свободной планировкой'
  9: 'studio', // 'Студия'
};
